import script from "./ellipsis-spinner.vue?vue&type=script&setup=true&lang=js"
export * from "./ellipsis-spinner.vue?vue&type=script&setup=true&lang=js"

import "./ellipsis-spinner.vue?vue&type=style&index=0&id=0a91534c&scoped=true&scss=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a91534c"]])

export default __exports__